<template>
	<div class="main-containter" id="top" v-title data-title="reservaion">
		<PHeader :checkId="'专业文章15'"  :activeNames="'资讯动态'"></PHeader>
		
		<article>
			<div style="height:150px;width:100%">
				<img src="https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/otherTitle.png" style="height: 100%;width: 100%;">
				<div class="fbannerUpText" style="position: absolute;top: 120px;color: white;font-weight: 600;font-size: 20px;left: calc(50% - 40px);">资讯动态</div>
				<div class="fbannerUpText" style="position: absolute;top: 155px;color: white;font-size: 14px;left: calc(50% - 31px);">Information Dynamics</div>
			</div>
			<div style="margin-top:10px;margin-left:3%;">
				<span style="color:#AAAAAA;font-size:14px;">首页 </span>
				<span style="color:#333333;font-size:14px;"> / 专业文章</span>
			</div>
			<div style="font-size: 22px;font-weight: 900;color: #AA1100;margin-left: 3%;margin-top:20px;text-align:center;width:94%;">专业文章</div>
			<div style="color: #AA1100;margin-left: 3%;margin-top: 5px;font-size: 14px;text-align:center;width:94%;">Professional Articles</div>
			<div style="margin-left: 3%;margin-top: 0px;text-align: center;width: 94%;margin-bottom: 20px;">
				<div style="width: 100%;height: 200px;margin-top: 20px;" v-for="(item,index) in tableData" :key="index">
						<div style="color: #333333;font-weight: 600;font-size: 18px;padding:10px 15px;cursor: pointer;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;cursor:pointer;" @click="toDetail(item,index)">{{item.title}}</div>
						<div style="color: #595959;font-size: 14px;margin-left: 10px;margin-right: 10px;overflow: hidden;display: -webkit-box;-webkit-line-clamp: 4;line-height: 24px;-webkit-box-orient: vertical;margin-bottom: 10px;">{{item.description}}</div>
						<div style="font-size: 14px;border-top: 1px solid #D7D7D7;width: 94%;margin-left: 3%;font-weight: 900;color: rgb(170, 170, 170);padding-top: 10px;">
							<div style="float: left;color: #AAAAAA;font-size: 14px;line-height: 20px;">{{item.publish.substring(0,10)}}</div>
							<img   @click="toDetail(item,index)" style="float: right;transform: rotate(-90deg);" src="../../assets/fImage/xiangyoujiantou.svg">
						</div>
					</div>
			</div>
			<el-pagination
				background
				layout="prev, pager, next"
				:page-size="4"
				:total="total"
				@current-change="handleCurrentChange">
			</el-pagination>
		</article>
		<Pooter></Pooter>
	</div>
</template>

<script>
	import PHeader from "../../components/p/PHeader.vue"
	import Pooter from "../../components/p/Pooter.vue"
	import {query} from "@/api/article";
	export default {
		name: "Index",
		components: {
			PHeader,
			Pooter
		},
		data() {
			return {
				tableData: [],
				total:0,
				pageNo: 1,
			}
		},
		mounted() {
			this.list()
		},
		activated(){
			document.getElementById("top").scrollIntoView({ behavior: "smooth" });
		},
		methods: {
			toDetail(item,index){
				this.$router.push(
					{
						path:'/phone/professionalArticlesDetail',
						query:{
							id:item.id
						}
					}
				);
			},
			handleCurrentChange(page){
				this.pageNo = page
				this.list()
			},
			list() {
				let param = {
					channelId:15,
					title: '',
					page: this.pageNo,
					pageSize: 4,
				}
				query(param).then(data => {
					this.tableData = data.data.list
					this.total = data.data.total
					// console.log("列表",this.tableData)
				}).catch(error => {
					this.$message.error(error)
				})
			},
		}
	}
</script>

<style lang="scss" scoped>
	.indexAboutUs{
		background: url("https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/phoneBusiness.png") no-repeat;
		height:100%;
		width:100%;
		overflow: hidden;
		background-size:cover;//或者background-size:1
	}
	.main-containter {
		.news{
			background-image: url(../../assets/fImage/homeNewsBg.jpg);
			background-size: cover;
		}
	}
	.main-containter ::v-deep .el-carousel__indicators--horizontal{
		display: none;
	}

	.parentCarousel ::v-deep .el-carousel__container{
		height: 100%;
	}
	body ::v-deep .v-modal{
		display: none;
	}
/* Reset */
 .btn-border-o:before{
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
}

/* Main Styles */

.btn {
  position: relative;
}

.btn-border-o {
  background-color: transparent;    
  border: 0;
  border-bottom: 1px solid #d0d0d0;
  color: #B8B8B8;
}
.btn-border-o:before {
  content: '';
  border-style: solid;
  position: absolute;
  z-index: 5;
  box-sizing: content-box;
}
.btn-border-o:before {
  width: 0;
  height: 100%;
  border-width: 0 0 1px 0;
  top: -0.5px;
  left: 0;
}
.btn-border-o:hover:before {
  width: 100%;
}
.btn-border-o:hover:after {
  height: 100%;
}
.btn-border-o.btn-green:hover {
  color: #98273A;
}
div ::v-deep .el-pagination.is-background .btn-next:disabled{
    margin: 0 5px;
    background-color: white !important;
    min-width: 30px;
    border-radius: 2px !important;
    font-weight: 400 !important;
    border: 1px solid #D9D9D9 !important;
		color: #C3C3C7 !important;
}
div ::v-deep .el-pagination.is-background .btn-prev:disabled{
    margin: 0 5px;
    background-color: white !important;
    min-width: 30px;
    border-radius: 2px !important;
    font-weight: 400 !important;
    border: 1px solid #D9D9D9 !important;
		color: #C3C3C7 !important;
}
div ::v-deep .el-pagination.is-background .btn-prev{
    /*进行修改未选中背景和字体*/
    margin: 0 5px;
    background-color: white !important;
    color: #606266 !important;
    min-width: 30px;
    border-radius: 2px !important;
    font-weight: 400 !important;
    border: 1px solid #D9D9D9 !important;
}
div ::v-deep .el-pagination.is-background .btn-next{
    /*进行修改未选中背景和字体*/
    margin: 0 5px;
    background-color: white !important;
    color: #606266 !important;
    min-width: 30px;
    border-radius: 2px !important;
    font-weight: 400 !important;
    border: 1px solid #D9D9D9 !important;
}
div ::v-deep .el-pagination.is-background .el-pager li{
    /*进行修改未选中背景和字体*/
    margin: 0 5px;
    background-color: white !important;
    color: #606266 !important;
    min-width: 30px;
    border-radius: 2px !important;
    font-weight: 400 !important;
    border: 1px solid #D9D9D9 !important;
}

div ::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active{
  /*进行修改选中项背景和字体*/
	background-color: #98273A !important;
  color:white !important;
  border-radius: 2px !important;
  font-weight: 400 !important;
  border: 1px solid #98273A !important;
}

div ::v-deep .el-pagination.is-background .el-pager li:hover{
   color: #98273A !important;/*hover时候的文字颜色*/
 }
div ::v-deep .el-pager li.active{
   color:#98273A !important;/*仅设置active时的文字颜色*/
 }
div ::v-deep .el-pagination{
	text-align: center;
	margin-bottom: 20px;
}
</style>
